import { api1C } from './api';

export const get1cProducts = (params) =>
    api1C.get('products', {
        params,
    });
